import { stringToDecimal } from '../utils/numberUtils'
import { Input } from '@/components/ui/input'
import { forwardRef, useState } from 'react'

export interface InputDecimalProps {
  id: string
  name: string
  label?: string
  value?: string
  onChange?: (value: string) => void
  onBlur?: () => void
  onFocus?: () => void
  disabled?: boolean
  required?: boolean
  allowNegative?: boolean
}

export const InputDecimal = forwardRef<HTMLInputElement, InputDecimalProps>(
  (props, ref) => {
    const {
      id,
      name,
      label,
      value,
      onBlur,
      onChange,
      onFocus,
      disabled,
      required,
      allowNegative = true
    } = props

    const [privateValue, setPrivateValue] = useState(value ?? '')

    function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
      const newValue = stringToDecimal(event.target.value, allowNegative)
      setPrivateValue(newValue)

      if (privateValue !== newValue) {
        onChange?.(newValue)
      }
    }

    return (
      <div>
        {label && <label htmlFor={id}>{label}</label>}
        <Input
          id={id}
          type='text'
          name={name}
          value={privateValue}
          onChange={handleChange}
          onBlur={onBlur}
          onFocus={onFocus}
          disabled={disabled}
          inputMode='decimal'
          aria-required={required}
          ref={ref}
        />
      </div>
    )
  }
)
InputDecimal.displayName = 'InputDecimal'
